module.exports = __webpack_public_path__ + "media/images/pages/team-4-177bea0fe50652e7d687395f8868efb5.jpg";